import {
  Briefcase as BriefcaseIcon,
  Home as HomeIcon,
  Office as OfficeIcon,
} from '@factorialco/factorial-one-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { LOCATION_TYPES } from 'modules/attendance/store/models/Shift'

export const getLocationTypes = () => [
  {
    id: LOCATION_TYPES.OFFICE ?? '',
    name: i18n.t('clock_in.widget.locations.office'),
    icon: OfficeIcon,
  },
  {
    id: LOCATION_TYPES.WORK_FROM_HOME ?? '',
    name: i18n.t('clock_in.widget.locations.home'),
    icon: HomeIcon,
  },
  {
    id: LOCATION_TYPES.BUSINESS_TRIP ?? '',
    name: i18n.t('clock_in.widget.locations.business_trip'),
    icon: BriefcaseIcon,
  },
]
